import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import axios from "../../../../../../Global/axios";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import { setArrayValues } from "./candidateListFunctions";
import { statusArray } from "./candidateListFunctions";

export const statusForupdateFlightDetails = [
  "VISA STAMPED",
  "VISA CANCELLED REQUIREMENT FULFILLED",
  "VISA CANCELLED",
];
export default function EditCandidate({
  showPromptElement,
  setShowPromptElement,
  candidateListData,
  projectId,
  setCandidateListData,
  updateVisaDetails,
  ResetFilter,
}) {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [sector, setSector] = useState("");
  const [nationality, setNationality] = useState("");
  const [religion, setReligion] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [actualPosition, setActualPosition] = useState("");
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");
  const [grade, setGrade] = useState("");
  const [basic, setBasic] = useState("");
  const [food, setFood] = useState("");
  const [fixedOt, setFixedOt] = useState("");
  const [hra, setHra] = useState("");
  const [travelAllowance, setTravelAllowance] = useState("");
  const [mobileAllowance, setMobileAllowance] = useState("");
  const [airTicketAllowance, setAirTicketAllowance] = useState("");
  const [additonalOt, setAdditonalOt] = useState("");
  const [OtherAllowance, setOtherAllowance] = useState("");
  const [dutyHours, setDutyHours] = useState("");
  const [fixedOtHours, setFixedOtHours] = useState("");
  const [contractDuration, setContractDuration] = useState("");
  const [ProbationPeriod, setProbationPeriod] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [emergencyContactPerson, setEmergencyContactPerson] = useState("");
  const [emergencyContactNumber, setEmergencyContactNumber] = useState("");
  const [covidVaccine, setCovidVaccine] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [VisaBlockNumber, setVisaBlockNumber] = useState("");
  const [VisaRefferenceNumber, setVisaRefferenceNumber] = useState("");
  const [VisaRefferenceNumberValidation, setVisaRefferenceNumberValidation] =
    useState("");
  const [changedValues, setChangedValues] = useState({
    id: showPromptElement?.id,
  });

  function formatDate(inputDate) {
    // Create a mapping of month abbreviations to their numerical equivalents
    const monthMap = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    // Convert input to a string (in case it's not)
    let value = String(inputDate);
    console.log("input date print......", inputDate);

    // Split the input date into parts
    const parts = value.split("-");

    // Check if the middle part (month) is a number or an abbreviation
    let month = parts[1];

    if (isNaN(month)) {
      // If the month is an abbreviation, map it to its numerical equivalent
      month = monthMap[month];
    }

    // Reformat the date
    const formattedDate = `${parts[2]}-${month}-${parts[0]}`;

    return formattedDate;
  }

  const reverseDate = (date) => {
    if (date) {
      return date.toString().split("-").reverse().join("-");
    } else {
      return "";
    }
  };

  const HandleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.put(
        `/dashboard/project-candidates/${projectId}`,
        { candidate: [changedValues] },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status == 200) {
        setLoading(false);
        setArrayValues(res.data.data, setCandidateListData);
        ResetFilter();
        dispatch(setAppError({ msg: res.data.message, color: "success" }));
        setShowPromptElement(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (error?.response?.data?.message) {
        dispatch(setAppError({ msg: error?.response?.data?.message }));
      } else {
        dispatch(setAppError({ msg: error?.message }));
      }
    }
  };

  useEffect(() => {
    if (showPromptElement?.editData) {
      const data = showPromptElement?.editData;
      console.log(data, "aj edit data");
      const selectionDate = formatDate(data?.selection_date);
      const dobDate = formatDate(data?.dob);
      const issuedDate = formatDate(data?.passport_issue_date);
      const expiryDate = formatDate(data?.passport_expiry_date);
      setSector(data?.sector_id);
      setNationality(data?.nationality_id);
      setReligion(data?.religion);
      setDate(selectionDate);
      setRemark(data?.approval_remark);
      setActualPosition(data?.job_position_id);
      setDob(dobDate);
      setAge(Number(data?.age));
      setGrade(data?.selection_grade);
      setBasic(Number(data?.basic));
      setFood(Number(data?.food));
      setFixedOt(Number(data?.fixed_ot));
      setHra(Number(data?.hra));
      setTravelAllowance(Number(data?.travel_allowance));
      setMobileAllowance(Number(data?.mobile_allowance));
      setAirTicketAllowance(Number(data?.air_ticket_allowance));
      setAdditonalOt(Number(data?.additional_ot));
      setOtherAllowance(Number(data?.other_allowance));
      setDutyHours(Number(data?.duty_hours));
      setFixedOtHours(Number(data?.fixed_ot_hours));
      setContractDuration(data?.duration_of_contract);
      setProbationPeriod(data?.probation_period);
      setPassportIssueDate(issuedDate);
      setPassportExpiryDate(expiryDate);
      setEmergencyContactPerson(data?.emergency_contact_person_in_home_country);
      setEmergencyContactNumber(
        Number(data?.emergency_contact_number_in_home_country)
      );
      setCovidVaccine(data?.covid_vaccine);
      setBloodGroup(data?.blood_group);
      setPassportNumber(data?.passport_number);
      setName(data?.name);
      if (updateVisaDetails) {
        setVisaRefferenceNumber(
          data?.visa_reference_number ? data?.visa_reference_number : ""
        );
        setVisaRefferenceNumberValidation(
          data?.visa_reference_number ? data?.visa_reference_number : ""
        );
        setVisaBlockNumber(data?.visa_block_number);
      } else {
        setStatus(data?.status);
      }
    }
  }, []);
  useEffect(() => {
    validation();
  });
  const validation = () => {
    const data = showPromptElement?.editData;
    const selectionDate = formatDate(data?.selection_date);
    const dobDate = formatDate(data?.dob);
    const issuedDate = formatDate(data?.passport_issue_date);
    const expiryDate = formatDate(data?.passport_expiry_date);

    if (updateVisaDetails) {
      if (
        data.sector_id == sector &&
        data?.nationality_id == nationality &&
        data?.religion == religion &&
        selectionDate == date &&
        data?.approval_remark == remark &&
        data?.job_position_id == actualPosition &&
        dobDate == dob &&
        data?.age == age &&
        data?.selection_grade == grade &&
        data?.basic == basic &&
        data?.food == food &&
        data?.fixed_ot == fixedOt &&
        data?.hra == hra &&
        data?.travel_allowance == travelAllowance &&
        data?.mobile_allowance == mobileAllowance &&
        data?.air_ticket_allowance == airTicketAllowance &&
        data?.additional_ot == additonalOt &&
        data?.other_allowance == OtherAllowance &&
        data?.duty_hours == dutyHours &&
        data?.fixed_ot_hours == fixedOtHours &&
        data?.duration_of_contract == contractDuration &&
        data?.probation_period == ProbationPeriod &&
        issuedDate == passportIssueDate &&
        expiryDate == passportExpiryDate &&
        data?.emergency_contact_person_in_home_country ==
          emergencyContactPerson &&
        data?.emergency_contact_number_in_home_country ==
          emergencyContactNumber &&
        data?.covid_vaccine == covidVaccine &&
        data?.blood_group == bloodGroup &&
        data?.passport_number == passportNumber &&
        data?.name == name &&
        VisaRefferenceNumberValidation == VisaRefferenceNumber &&
        data?.visa_block_number == VisaBlockNumber
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    } else {
      if (
        data.sector_id == sector &&
        data?.nationality_id == nationality &&
        data?.religion == religion &&
        selectionDate == date &&
        data?.approval_remark == remark &&
        data?.job_position_id == actualPosition &&
        dobDate == dob &&
        data?.age == age &&
        data?.selection_grade == grade &&
        data?.basic == basic &&
        data?.food == food &&
        data?.fixed_ot == fixedOt &&
        data?.hra == hra &&
        data?.travel_allowance == travelAllowance &&
        data?.mobile_allowance == mobileAllowance &&
        data?.air_ticket_allowance == airTicketAllowance &&
        data?.additional_ot == additonalOt &&
        data?.other_allowance == OtherAllowance &&
        data?.duty_hours == dutyHours &&
        data?.fixed_ot_hours == fixedOtHours &&
        data?.duration_of_contract == contractDuration &&
        data?.probation_period == ProbationPeriod &&
        issuedDate == passportIssueDate &&
        expiryDate == passportExpiryDate &&
        data?.emergency_contact_person_in_home_country ==
          emergencyContactPerson &&
        data?.emergency_contact_number_in_home_country ==
          emergencyContactNumber &&
        data?.covid_vaccine == covidVaccine &&
        data?.blood_group == bloodGroup &&
        data?.passport_number == passportNumber &&
        data?.name == name &&
        data?.status == status
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  };
  console.log(
    "selection date to be capctured here",
    date,
    showPromptElement?.editData
  );
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen  bg-black/50 justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="w-full relative max-w-md   h-[500px] overflow-y-auto uppercase min-h-[14rem] rounded-md bg-white/90">
        <form
          onSubmit={HandleFormSubmit}
          className="flex flex-col gap-3 px-2 py-3"
        >
          <div className="flex justify-between  items-center">
            <h2 className="block text-lg text-left font-bold text-gray-700 ">
              Edit Candidate
            </h2>
            <AiFillCloseCircle
              className="cursor-pointer"
              size={"1.4rem"}
              onClick={() => {
                setShowPromptElement(false);
              }}
            />
          </div>
          <div className=" p-4  text-center flex justify-center flex-col">
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                SELECTION SECTOR
              </label>
              <select
                value={sector}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setSector(e.target.value);
                  if (
                    String(showPromptElement?.editData?.sector_id) !==
                      String(e.target.value) &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      sector_id: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("sector_id" in copiedObg) {
                      delete copiedObg["sector_id"];
                    }
                  }
                }}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.sector?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            {!updateVisaDetails && (
              <div className="mb-3">
                <label className="block text-left mb-1 text-sm">STATUS</label>
                <select
                  value={status}
                  className="select select-bordered select-sm w-full"
                  onChange={(e) => {
                    setStatus(e.target.value);
                    if (
                      String(showPromptElement?.editData?.status) !==
                        String(e.target.value) &&
                      e.target.value != ""
                    ) {
                      setChangedValues((prevValues) => ({
                        ...prevValues,
                        status: e.target.value,
                      }));
                    } else {
                      const copiedObg = changedValues;
                      if ("status" in copiedObg) {
                        delete copiedObg["status"];
                      }
                    }
                  }}
                  required
                >
                  <option value={""} hidden></option>
                  {statusArray?.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                NATIONALITY
              </label>
              <select
                value={nationality}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setNationality(e.target.value);
                  if (
                    String(showPromptElement?.editData?.nationality_id) !==
                      String(e.target.value) &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      nationality_id: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("nationality_id" in copiedObg) {
                      delete copiedObg["nationality_id"];
                    }
                  }
                }}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.nationality?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">RELIGION</label>
              <select
                value={religion}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setReligion(e.target.value);
                  if (
                    showPromptElement?.editData?.religion != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      religion: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("religion" in copiedObg) {
                      delete copiedObg["religion"];
                    }
                  }
                }}
              >
                <option value={""} hidden></option>
                <option value={"MUSLIM"}>MUSLIM</option>
                <option value={"NON MUSLIM"}>NON MUSLIM</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DATE OF SELECTION
              </label>
              <input
                value={date}
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                required
                onChange={(e) => {
                  setDate(e.target.value);
                  const date = formatDate(
                    showPromptElement?.editData.selection_date
                  );
                  if (date != e.target.value && e.target.value != "") {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      selection_date: reverseDate(e.target.value),
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("selection_date" in copiedObg) {
                      delete copiedObg["selection_date"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                APPROVAL REMARK
              </label>
              <input
                value={remark}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setRemark(value);

                  if (
                    showPromptElement?.editData?.approval_remark != value &&
                    value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      approval_remark: value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("approval_remark" in copiedObg) {
                      delete copiedObg["approval_remark"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMPLOYEE NAME
              </label>
              <input
                value={name}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                name="employee_name"
                placeholder="Employee name"
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setName(value);
                  if (
                    showPromptElement?.editData?.name != value &&
                    value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      name: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("name" in copiedObg) {
                      delete copiedObg["name"];
                    }
                  }
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT NO
              </label>
              <input
                value={passportNumber}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                required
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setPassportNumber(value);
                  if (
                    showPromptElement?.editData?.passport_number != value &&
                    value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      passport_number: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("passport_number" in copiedObg) {
                      delete copiedObg["passport_number"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                ACTUAL PROFESSION
              </label>
              <select
                value={actualPosition}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setActualPosition(e.target.value);
                  if (
                    showPromptElement?.editData.job_position_id !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      job_position_id: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("job_position_id" in copiedObg) {
                      delete copiedObg["job_position_id"];
                    }
                  }
                }}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.job_possition?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DATE OF BIRTH
              </label>
              <input
                value={dob}
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setDob(e.target.value);
                  const date = formatDate(showPromptElement?.editData?.dob);
                  if (date != e.target.value && e.target.value != "") {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      dob: reverseDate(e.target.value),
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("dob" in copiedObg) {
                      delete copiedObg["dob"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">AGE </label>
              <input
                value={age}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAge(e.target.value);
                  if (
                    showPromptElement?.editData.age != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      age: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("age" in copiedObg) {
                      delete copiedObg["age"];
                    }
                  }
                }}
              />
            </div>
            {updateVisaDetails && (
              <>
                <div className="mb-3">
                  <label className="block text-left mb-1 text-sm">
                    VISA BLOCK NUMBER{" "}
                  </label>
                  <input
                    value={VisaBlockNumber}
                    className="uppercase input-sm w-full input input-bordered"
                    type="text"
                    onChange={(e) => {
                      let value = e.target.value?.toUpperCase();
                      setVisaBlockNumber(value);
                      if (
                        showPromptElement?.editData.visa_block_number !=
                          value &&
                        value != ""
                      ) {
                        setChangedValues((prevValues) => ({
                          ...prevValues,
                          visa_block_number: value,
                        }));
                      } else {
                        const copiedObg = changedValues;
                        if ("age" in copiedObg) {
                          delete copiedObg["age"];
                        }
                      }
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label className="block text-left mb-1 text-sm">
                    VISA REFERENCE NUMBER
                  </label>
                  <input
                    value={VisaRefferenceNumber}
                    className="uppercase input-sm w-full input input-bordered"
                    type="text"
                    onChange={(e) => {
                      setVisaRefferenceNumber(e.target.value);
                      if (
                        showPromptElement?.editData.visa_reference_number !=
                          e.target.value &&
                        e.target.value != ""
                      ) {
                        setChangedValues((prevValues) => ({
                          ...prevValues,
                          visa_reference_number: e.target.value,
                        }));
                      } else {
                        const copiedObg = changedValues;
                        if ("age" in copiedObg) {
                          delete copiedObg["age"];
                        }
                      }
                    }}
                  />
                </div>
              </>
            )}

            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                SELECTION GRADE
              </label>
              <input
                value={grade}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setGrade(value);
                  if (
                    showPromptElement?.editData?.selection_grade != value &&
                    value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      selection_grade: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("selection_grade" in copiedObg) {
                      delete copiedObg["selection_grade"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">BASIC </label>
              <input
                value={basic}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setBasic(e.target.value);
                  if (
                    showPromptElement?.editData?.basic != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      basic: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("basic" in copiedObg) {
                      delete copiedObg["basic"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">FOOD </label>
              <input
                value={food}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFood(e.target.value);
                  if (
                    showPromptElement?.editData?.food != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      food: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("food" in copiedObg) {
                      delete copiedObg["food"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Fixed OT
              </label>
              <input
                value={fixedOt}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFixedOt(e.target.value);
                  if (
                    showPromptElement?.editData?.fixed_ot != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      fixed_ot: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("fixed_ot" in copiedObg) {
                      delete copiedObg["fixed_ot"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">HRA</label>
              <input
                value={hra}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setHra(e.target.value);
                  if (
                    showPromptElement?.editData?.hra != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      hra: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("hra" in copiedObg) {
                      delete copiedObg["hra"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Travel Allowance
              </label>
              <input
                value={travelAllowance}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setTravelAllowance(e.target.value);
                  if (
                    showPromptElement?.editData?.travel_allowance !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      travel_allowance: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("travel_allowance" in copiedObg) {
                      delete copiedObg["travel_allowance"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Mobile Allowance
              </label>
              <input
                value={mobileAllowance}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setMobileAllowance(e.target.value);
                  if (
                    showPromptElement?.editData?.mobile_allowance !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      mobile_allowance: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("mobile_allowance" in copiedObg) {
                      delete copiedObg["mobile_allowance"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Air Ticket Allowance
              </label>
              <input
                value={airTicketAllowance}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAirTicketAllowance(e.target.value);
                  if (
                    showPromptElement?.editData?.air_ticket_allowance !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      air_ticket_allowance: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("air_ticket_allowance" in copiedObg) {
                      delete copiedObg["air_ticket_allowance"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Additional OT
              </label>
              <input
                value={additonalOt}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAdditonalOt(e.target.value);
                  if (
                    showPromptElement?.editData?.additional_ot !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      additional_ot: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("additional_ot" in copiedObg) {
                      delete copiedObg["additional_ot"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Other Allowance
              </label>
              <input
                value={OtherAllowance}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setOtherAllowance(e.target.value);
                  if (
                    showPromptElement?.editData?.other_allowance !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      other_allowance: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("other_allowance" in copiedObg) {
                      delete copiedObg["other_allowance"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                DUTY HOURS
              </label>
              <input
                value={dutyHours}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setDutyHours(e.target.value);
                  if (
                    showPromptElement?.editData?.duty_hours != e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      duty_hours: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("duty_hours" in copiedObg) {
                      delete copiedObg["duty_hours"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                FIXED OT HOURS
              </label>
              <input
                value={fixedOtHours}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFixedOtHours(e.target.value);
                  if (
                    showPromptElement?.editData?.fixed_ot_hours !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      fixed_ot_hours: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("fixed_ot_hours" in copiedObg) {
                      delete copiedObg["fixed_ot_hours"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DURATION OF CONTRACT
              </label>
              <select
                value={contractDuration}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setContractDuration(e.target.value);
                  if (
                    showPromptElement?.editData?.duration_of_contract !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      duration_of_contract: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("duration_of_contract" in copiedObg) {
                      delete copiedObg["duration_of_contract"];
                    }
                  }
                }}
              >
                <option value={""} hidden></option>
                <option value={"6 MONTHS"}>6 MONTHS</option>
                <option value={"12 MONTHS"}>12 MONTHS</option>
                <option value={"24 MONTHS"}>24 MONTHS</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PROBATION PERIOD
              </label>
              <select
                value={ProbationPeriod}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setProbationPeriod(e.target.value);
                  if (
                    showPromptElement?.editData?.probation_period !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      probation_period: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("probation_period" in copiedObg) {
                      delete copiedObg["probation_period"];
                    }
                  }
                }}
              >
                <option value={""} hidden></option>
                <option value={"3 MONTHS"}>3 MONTHS</option>
                <option value={"6 MONTHS"}>6 MONTHS</option>
                <option value={"9 MONTHS"}>9 MONTHS</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT ISSUE DATE
              </label>
              <input
                value={passportIssueDate}
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  {
                    setPassportIssueDate(e.target.value);
                    const date = formatDate(
                      showPromptElement?.editData.passport_issue_date
                    );
                    if (date != e.target.value && e.target.value != "") {
                      setChangedValues((prevValues) => ({
                        ...prevValues,
                        passport_issue_date: reverseDate(e.target.value),
                      }));
                    } else {
                      const copiedObg = changedValues;
                      if ("passport_issue_date" in copiedObg) {
                        delete copiedObg["passport_issue_date"];
                      }
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT EXPIRY DATE
              </label>
              <input
                value={passportExpiryDate}
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setPassportExpiryDate(e.target.value);
                  const date = formatDate(
                    showPromptElement?.editData.passport_expiry_date
                  );
                  if (date != e.target.value && e.target.value != "") {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      passport_expiry_date: reverseDate(e.target.value),
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("passport_expiry_date" in copiedObg) {
                      delete copiedObg["passport_expiry_date"];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMERGENCY CONTACT PERSON IN HOME COUNTRY
              </label>
              <input
                value={emergencyContactPerson}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  setEmergencyContactPerson(e.target.value);
                  if (
                    showPromptElement?.editData
                      ?.emergency_contact_person_in_home_country !=
                    e.target.value
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      emergency_contact_person_in_home_country: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if (
                      "emergency_contact_person_in_home_country" in copiedObg
                    ) {
                      delete copiedObg[
                        "emergency_contact_person_in_home_country"
                      ];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMERGENCY CONTACT NUMBER IN HOME COUNTRY
              </label>
              <input
                value={emergencyContactNumber}
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setEmergencyContactNumber(e.target.value);
                  if (
                    showPromptElement?.editData
                      ?.emergency_contact_number_in_home_country !=
                    e.target.value
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      emergency_contact_number_in_home_country: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if (
                      "emergency_contact_number_in_home_country" in copiedObg
                    ) {
                      delete copiedObg[
                        "emergency_contact_number_in_home_country"
                      ];
                    }
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                COVID VACCINE
              </label>
              <select
                value={covidVaccine}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setCovidVaccine(e.target.value);
                  if (
                    showPromptElement?.editData?.covid_vaccine !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      covid_vaccine: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("covid_vaccine" in copiedObg) {
                      delete copiedObg["covid_vaccine"];
                    }
                  }
                }}
              >
                <option value={""} hidden></option>
                <option value={"DOSE 1"}>DOSE 1</option>
                <option value={"DOSE 2"}>DOSE 2</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                BLOOD GROUP
              </label>
              <select
                value={bloodGroup}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setBloodGroup(e.target.value);
                  if (
                    showPromptElement?.editData?.blood_group !=
                      e.target.value &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      blood_group: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("blood_group" in copiedObg) {
                      delete copiedObg["blood_group"];
                    }
                  }
                }}
              >
                <option value={""} hidden></option>
                <option value={"A+"}>A+</option>
                <option value={"B+"}>B+</option>
                <option value={"AB+"}>AB+</option>
                <option value={"AB-"}>AB-</option>
                <option value={"O+"}>O+</option>
                <option value={"O-"}>O-</option>
                <option value={"A-"}>A-</option>
                <option value={"B-"}>B-</option>
              </select>
            </div>
          </div>

          <div className="flex gap-3  m-5 justify-center items-center">
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-slate-600"
              disabled={loading}
              onClick={() => {
                setShowPromptElement(false);
              }}
            >
              Cancel
            </button>
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              type="submit"
              disabled={loading || disabled}
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
